import { matchPath } from 'react-router-dom';
import { ROUTES } from '../components/constants/routes.js';

/** DOM mount point for js-e2e banner injection */
export const E2E_COMMS_WRAPPER_ID = 'e2e-comms-wrapper';

/**
 * E2E comms page IDs (js-e2e + comms.json `pages` field).
 * Share with E2E comms when authoring alerts.
 */
export const E2E_PAGE_IDS = {
  SIGNIN: 'signin',
  SIGNUP: 'signup',
  FORGOT_UN_PW: 'forgot-unpw',
  POST_SIGNIN: 'postsignin',
};

/** Default `_e2e_comms.pages` when AirDrop `e2eCommsPages` is unset */
export const DEFAULT_E2E_COMMS_PAGES = [
  E2E_PAGE_IDS.SIGNIN,
  E2E_PAGE_IDS.SIGNUP,
  E2E_PAGE_IDS.FORGOT_UN_PW,
  E2E_PAGE_IDS.POST_SIGNIN,
].join(',');

/**
 * IES UI routes that show the E2E banner → E2E page id for js-e2e filtering.
 * Order: more specific paths before generic signin.
 */
const ROUTE_TO_E2E_PAGE = [
  { path: ROUTES.CREATE_ACCOUNT_LINK_ACCOUNTS_INTERNAL, pageId: E2E_PAGE_IDS.SIGNUP },
  { path: ROUTES.CREATE_ACCOUNT_INTERNAL, pageId: E2E_PAGE_IDS.SIGNUP },
  { path: ROUTES.SOCIAL_LOGIN_CR, pageId: E2E_PAGE_IDS.SIGNUP },
  { path: ROUTES.FORGOT_UN_PW_INTERNAL, pageId: E2E_PAGE_IDS.FORGOT_UN_PW },
  { path: ROUTES.AUTOLOGIN, pageId: E2E_PAGE_IDS.SIGNIN },
  { path: ROUTES.LOGIN_INTERNAL, pageId: E2E_PAGE_IDS.SIGNIN },
  { path: ROUTES.SOCIAL_LOGIN, pageId: E2E_PAGE_IDS.SIGNIN },
];

/**
 * @param {string} pathname
 * @returns {string|null} E2E page id when route supports the banner; otherwise null
 */
export function getE2ePageIdForPathname(pathname) {
  const match = ROUTE_TO_E2E_PAGE.find(({ path }) => matchPath({ path, end: true }, pathname));
  return match?.pageId ?? null;
}

export function isE2eCommsEnabled() {
  return Boolean(window?.appAirDrop?.config?.e2eCommsEnabled);
}
